import { cx } from "../../lib/utils";

interface IconProps {
  name: string;
  className?: string;
}

/** Material Symbols Outlined glyph (see index.html's font link + global.css's
 * .material-symbols-outlined rule). `name` is the icon's ligature name, e.g.
 * "inbox", "search", "expand_more" — see fonts.google.com/icons. */
export function Icon({ name, className }: IconProps) {
  return (
    <span className={cx("material-symbols-outlined", className)} aria-hidden="true">
      {name}
    </span>
  );
}
